import Button from 'atoms/button';
import Icon from 'atoms/icon';

export default function NoServicesCTA({ onClick }) {
  return (
    <div className="flex-row align-center justify-center h-100 no-services-cta">
      <div className="flex-column align-center">
        <Icon name="service" />
        <h2 className="f26 mb-5 mt-15">Set up services</h2>
        <p className="text-center mb-25">
          Your account is currently hidden. Add your service list, descriptions
          and pricing to be discoverable on PawCare.
        </p>
        <Button text="Add services" size="medium" onClick={onClick} />
      </div>
    </div>
  );
}
